import type { SVGProps } from 'react';
const DawnFlagKY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-KY_svg__a)">
      <path fill="#07319C" d="M0 0h22v16H0z" />
      <path
        fill="#FAD051"
        fillRule="evenodd"
        d="M16.238 5.333c.868 0 1.572-.477 1.572-1.066S17.106 3.2 16.238 3.2c-.867 0-1.571.478-1.571 1.067s.704 1.066 1.571 1.066"
        clipRule="evenodd"
      />
      <path
        fill="url(#dawn-flag-KY_svg__b)"
        fillRule="evenodd"
        d="M13.62 8V4.267h5.237V8c0 2.667-2.619 3.733-2.619 3.733S13.62 10.667 13.62 8"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-KY_svg__c"
        width={6}
        height={8}
        x={13}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M13.62 8V4.267h5.237V8c0 2.667-2.619 3.733-2.619 3.733S13.62 10.667 13.62 8"
          clipRule="evenodd"
        />
      </mask>
      <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-KY_svg__c)">
        <path fill="#CF142C" d="M13.62 4.267h5.237v1.066H13.62z" />
        <path
          fill="#125FBA"
          d="M18.857 6.4H13.62v1.067h5.238zM13.62 8.533h5.238V9.6H13.62zm0 2.134h5.238v1.066H13.62z"
        />
      </g>
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M3.667 3.2 0 0h.524L4.19 2.667h1.048L9.428 0v.364a.33.33 0 0 1-.137.27L5.761 3.2v1.067L9.078 7.16a.175.175 0 0 1-.115.307"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.667 3.2v1.067L0 6.933v.534L4.19 4.8H5.24l3.62 2.633a.175.175 0 0 0 .218-.273L5.762 4.267V3.2L9.292.633a.33.33 0 0 0 .137-.27V0l-4.19 2.667H4.19L.524 0H0zm.74-1.2L.742-.667h-2.518L3 3.503v.424L-.666 6.594V8.68l5.051-3.214h.637l3.445 2.505a.84.84 0 0 0 .495.161c.778 0 1.14-.964.554-1.476L6.429 3.964V3.54l3.255-2.368a1 1 0 0 0 .412-.808v-1.578L5.044 2z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 2.667V4.8h3.667v2.533c0 .369.298.667.666.667h.762a.667.667 0 0 0 .667-.667V4.8h3.524a.667.667 0 0 0 .666-.667v-.8a.667.667 0 0 0-.666-.666H5.762V0H3.667v2.667z"
        clipRule="evenodd"
      />
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M0 3.2h4.19V0h1.048v3.2h4.19v1.067h-4.19v3.2H4.19v-3.2H0z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-KY_svg__b"
        x1={13.619}
        x2={13.619}
        y1={4.267}
        y2={11.733}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#F0F0F0" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagKY;
